import JapanFlagImage from '@/assets/icons/japan-flag.svg';
import BskdnImage from '@/assets/images/bskdn.png';
import {
  Col,
  Flex,
  Image,
  LogoIcon,
  LogoImage,
  Row,
  theme,
} from '@/components';
import type { FC } from 'react';
import { useNavigate } from 'react-router';

type Props = {
  collapsed?: boolean;
  isPopupWindow?: boolean;
};

export const ServiceLogo: FC<Props> = ({ collapsed, isPopupWindow }) => {
  const { token } = theme.useToken();

  const navigate = useNavigate();
  const onClick = () => {
    navigate('/');
  };

  return (
    <Row
      style={{
        borderBottom: isPopupWindow
          ? undefined
          : `1px solid ${token.colorFill}`,
        height: isPopupWindow ? 48 : 80,
      }}
      align="middle"
      justify="center"
    >
      <Col>
        {collapsed ? (
          <LogoIcon onClick={isPopupWindow ? undefined : onClick} />
        ) : (
          <Flex vertical align="flex-start">
            <Flex align="center" gap={8}>
              <Image
                src={BskdnImage}
                fallback={BskdnImage}
                alt="logo image"
                width={100}
                preview={false}
              />
              <Image
                src={JapanFlagImage}
                alt="japan flag"
                width={40}
                preview={false}
                style={{ border: `1px solid ${token.colorBorder}`, margin: 4 }}
              />
            </Flex>
            <LogoImage onClick={isPopupWindow ? undefined : onClick} />
          </Flex>
        )}
      </Col>
    </Row>
  );
};
